// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3CQ4X","colMaxWidth":"Table_colMaxWidth__1qNXJ"};